import { jsx as _jsx } from "@redneckz/uni-jsx/jsx-runtime";
import { InputRange } from '../InputRange/InputRange.js';
const STEP_DAYS = 1;
export const renderDaysInput = (props) => (_jsx(InputRange, { items: [`От ${daysText(props.min || 0)}`, `До ${daysText(props.max || 0)}`], step: STEP_DAYS, ...props }));
const daysText = (days) => `${days} ${Number(days) % 10 === 1 ? 'дня' : 'дней'}`;
//# sourceMappingURL=renderDaysInput.js.map